const SEARCH_ICON = (
  <svg
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className="size-full"
  >
    <path d="M14.3519 13.6464L11.2226 10.5176C12.1296 9.42871 12.5819 8.03201 12.4853 6.6181C12.3888 5.20419 11.7509 3.88193 10.7043 2.92638C9.65768 1.97082 8.28297 1.45555 6.86613 1.48775C5.4493 1.51995 4.09942 2.09714 3.0973 3.09926C2.09519 4.10137 1.518 5.45125 1.4858 6.86808C1.4536 8.28492 1.96887 9.65963 2.92442 10.7062C3.87997 11.7528 5.20224 12.3908 6.61615 12.4873C8.03006 12.5838 9.42676 12.1315 10.5157 11.2245L13.6444 14.3539C13.6909 14.4003 13.746 14.4372 13.8067 14.4623C13.8674 14.4875 13.9325 14.5004 13.9982 14.5004C14.0639 14.5004 14.1289 14.4875 14.1896 14.4623C14.2503 14.4372 14.3055 14.4003 14.3519 14.3539C14.3984 14.3074 14.4352 14.2523 14.4604 14.1916C14.4855 14.1309 14.4985 14.0658 14.4985 14.0001C14.4985 13.9344 14.4855 13.8694 14.4604 13.8087C14.4352 13.748 14.3984 13.6928 14.3519 13.6464ZM2.49819 7.00014C2.49819 6.11013 2.76211 5.2401 3.25658 4.50008C3.75104 3.76006 4.45385 3.18328 5.27611 2.84268C6.09838 2.50209 7.00318 2.41298 7.8761 2.58661C8.74901 2.76024 9.55083 3.18883 10.1802 3.81816C10.8095 4.4475 11.2381 5.24932 11.4117 6.12224C11.5854 6.99515 11.4962 7.89995 11.1556 8.72222C10.8151 9.54449 10.2383 10.2473 9.49826 10.7418C8.75824 11.2362 7.88821 11.5001 6.99819 11.5001C5.80512 11.4988 4.66130 11.0243 3.81767 10.1807C2.97404 9.33704 2.49951 8.19321 2.49819 7.00014Z" />
  </svg>
)

export default function SearchBar({
  value,
  onChange,
  placeholder = 'Search...',
  className = 'group relative flex min-w-0 overflow-hidden rounded-card w-[220px] max-mobile:w-full',
}) {
  return (
    <div className={className} data-testid="search-bar">

      <div className="flex w-full shrink-0 items-center text-sm/sm rounded-pill border-[0.5px] transition-[background-color,border-color,box-shadow] text-ink light:shadow-[inset_0_var(--hl-y)_0_0_var(--hl-top)] gap-2 rounded-card! border-line bg-fill hover:bg-fill light:border-(--ring-crisp) light:bg-surface light:hover:bg-surface h-9 px-3 max-mobile:h-(--control-h-lg)">
        <span
          data-icon="true"
          className="flex items-center justify-center shrink-0 text-muted size-4"
        >
          {SEARCH_ICON}
        </span>
        <span className="contents">
          <input
            className="w-full min-w-0 bg-transparent font-sans text-sm transition-colors outline-none max-mobile:text-xl max-mobile:leading-lg max-mobile:placeholder:text-sm placeholder:text-muted text-left placeholder:text-left"
            placeholder={placeholder}
            aria-label={placeholder}
            enterKeyHint="search"
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck="false"
            value={value}
            name="search"
            onChange={(event) => onChange(event.target.value)}
          />
        </span>
      </div>
    </div>
  )
}
